import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the main container back to the top on every navigation. Admin
 * pages live inside a flex layout, so we reset the scrollable <main>
 * element rather than window.scrollTo.
 */
export function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const main = document.getElementById('main');
    if (main) main.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search]);

  return null;
}
